// extracted by mini-css-extract-plugin
module.exports = {"text":"Feature_text__Y5dT3"};